export default __webpack_public_path__ + "static/media/banner-doctor.bac41703.png";